




import Vue from "vue";
import Layout from "./components/Layout.vue";
import Sticky from "./directives/Sticky";

const App = Vue.extend({
  components: { Layout },
  mounted() {
    // Vuetify ripple: Enterre rajzol (keydown), felengedésre tüntet el (keyup) — ha a click a keydown alatt elviszi a fókuszt (popover/dialog nyílik), a keyup máshova érkezik és a hullám a gombon ragad; fókuszvesztésnél szintetikus keyup-pal záratjuk le.
    document.addEventListener("focusout", (e) => {
      const el = e.target as (HTMLElement & { _ripple?: { enabled?: boolean } }) | null;
      if (el?._ripple?.enabled) el.dispatchEvent(new KeyboardEvent("keyup"));
    }, true);
  },
});

Vue.directive("sticky", Sticky);

export default App;
